module.exports = __webpack_public_path__ + "img/home_card_1.ef2f0b7a.webp";